import Vue from 'vue'
export default {
  //update new user details
  updateEnableActions (state, enableActions) {
    state.enableActions = enableActions
  },

  updateAuthUser (state, authUser){
    state.authUser = authUser
  },

  updateUserFirstName (state, firstname) {
    state.authUser.firstName = firstname
    Vue.$cookies.set("userFirstName", state.authUser.firstName)
  },

  updateUserId (state, userId) {
    state.authUser.userId = userId
    window.localStorage.setItem('userId', state.authUser.userId)
  },

  updateUserLastName (state, lastname) {
    state.authUser.lastName = lastname;
    Vue.$cookies.set("userLastName", state.authUser.lastName)

  },
  
  updateUserAddress (state, address) {
    state.authUser.address = address
    Vue.$cookies.set("userAddress", state.authUser.address)
  },

  updateUserCity (state, city) {
    state.authUser.city = city
    Vue.$cookies.set("userCity", state.authUser.city)
  },

  updateUserState (state, userState) {
    state.authUser.state = userState
    Vue.$cookies.set("userState", state.authUser.userState)
  },

  updateUserFullName (state, firstname, lastname) {
    state.authUser.userFullName = firstname + ' ' + lastname;
    Vue.$cookies.set("userFullName", state.authUser.userFullName)
  },

  updatePassword(state, password) {
    state.authUser.password = password
  },


  updateUserPhonenumber (state, phonenumber) {
    state.authUser.phonenumber = phonenumber;
    if(phonenumber !== null || undefined){
      Vue.$cookies.set("phoneNumber", state.authUser.phoneCountryCode + state.authUser.phonenumber)
    }
  },
  updateUserPhoneCountryCode(state, countryCode) {
    state.authUser.phoneCountryCode = countryCode;
  },

  updateUserEmail (state, email) {
    state.authUser.email = email;
    Vue.$cookies.set("userEmail", state.authUser.email)
  },

  updateUserBusinessName (state, businessName) {
    state.authUser.businessName = businessName
    window.localStorage.setItem('merchantName', state.authUser.businessName )
  },

  updateUserAccountNumber (state, accountNumber) {
    state.authUser.accountNumber = accountNumber
    window.localStorage.setItem('accountNumber', state.authUser.accountNumber )
  },

  updateUserBusinessType (state, businessType) {
    state.authUser.businessType = businessType
  },

  updateSearch(state, data = {}){
    window.localStorage.setItem('Search', JSON.stringify(data));
  },

  updateTerminalsSearch(state, data = {}) {
    window.localStorage.setItem('TerminalsSummary', JSON.stringify(data));
  },

  updateTxnSummary(state, data = {}){
    window.localStorage.setItem('TxnSummary', JSON.stringify(data));
  },

  updateAgentSummary(state, data = {}){
    window.localStorage.setItem('AgentSummary', JSON.stringify(data));
  },

  updateAgentTxn(state, data = {}){
    window.localStorage.setItem('AgentTxn', JSON.stringify(data));
  },

  updateDispenseErrorFilter(state, data = {}){
    window.localStorage.setItem('DispenseError', JSON.stringify(data));
  },

  updateTransactionsSearch(state, data = {}){
    window.localStorage.setItem('TransactionsSearch', JSON.stringify(data));
  },

  updateWalletFundingSearch(state, data = {}){
    window.localStorage.setItem('WalletFundingSearch', JSON.stringify(data));
  },

  updateSingleBalanceFullSearch(state, data = {}){
    window.localStorage.setItem('SingleWalletHistorySearch', JSON.stringify(data));
  },

  updateUserBusinessDescription (state, businessDescription) {
    state.authUser.businessDescription = businessDescription
  },

  updateUserMerchantId (state, id) {
    state.authUser.merchantId = id;
    window.localStorage.setItem('merchantId', state.authUser.merchantId);
  },

  updateUserMerchantPosState (state, posMerchant) {
    state.authUser.posMerchant = posMerchant;
    window.localStorage.setItem('posMerchant', state.authUser.posMerchant);
  },

  updateUserPermissions (state, permissions) {
    state.authUser.permissions = permissions;
    window.localStorage.setItem('permissions', JSON.stringify(state.authUser.permissions));
  },

  updateMerchantList (state, list) {
    state.authUser.merchantList = list;
    window.localStorage.setItem('List', JSON.stringify(state.authUser.merchantList));
  },

  updateCompliance (state, compliance) {
    state.authUser.compliance = compliance;
    window.localStorage.setItem('compliance', state.authUser.compliance)
  },

  updateBanksList(state, obj){
    if(state.banksList.length>0){
      state.banksList.length = 0
    }
    state.banksList.push(obj);
    window.localStorage.setItem('bankList', JSON.stringify(state.banksList))
  },

  emptyPrimaryCurrencies(state){
    state.authUser.walletCurrencyList.length = 0
  },
  updatePrimaryWalletCurrencies(state, obj){
    state.authUser.walletCurrencyList.push(obj);
    window.localStorage.setItem('walletList', JSON.stringify(state.authUser.walletCurrencyList))
  },

  updateSelectedCurrency(state, arr){
    state.authUser.currenciesSelected = arr;
  },

  updateSelectedPaymentType(state, arr){
    state.authUser.paymentSelected = arr;
  },

  updateErrors(state, errors){
    if(state.authUser.apiErrors.length > 0){
      state.authUser.apiErrors.length = 0;
    }
    state.authUser.apiErrors.push(errors);
  }

}



// WEBPACK FOOTER //
// ./src/store/mutations.js